import { FAPI_SERVICE_CASE_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from './apiHttpClient'

const apiClient = new HttpClient(environment.serviceFAPIUrl)

export const customerServiceCaseService = {
  async createServiceCase(serviceCaseData = {}) {
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/create`

    return apiClient.post(url, {
      body: serviceCaseData,
    })
  },

  async validateMaterialNumber({
    materialNumber,
    countryId,
  }: {
    materialNumber: string
    countryId: string
  }) {
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/${materialNumber}/validate`

    return apiClient.get(url, {
      params: {
        countryId,
      },
    })
  },

  async uploadExcludeMachinesList({ countryId, fileName, file }) {
    const formData = new FormData()
    formData.append('FormFile', file)
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/excluded-upload`

    return apiClient.post(url, {
      body: formData,
      headers: {
        'content-type': 'multipart/form-data',
      },
      params: {
        country: countryId,
        fileName,
      },
    })
  },

  async downloadExcludedMachinesList(countryId: string) {
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/excluded-download`

    return apiClient.get(url, {
      params: {
        countryId,
      },
    })
  },
}
